class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle = this.querySelector('details'); 
    this.querySelector('summary').addEventListener('mouseenter', this.showMenu.bind(this));
    this.querySelector('details').addEventListener('click', this.showMenu.bind(this));
    this.querySelector('details').addEventListener('mouseleave', this.hideMenu.bind(this));  
  }
  showMenu(){ 
    if(this.mainDetailsToggle.hasAttribute('open')) {
      return;
    }
    document.querySelectorAll('header-menu details[open]').forEach((menu) => {
      const megaMenuContent = menu.querySelector('.mega-menu__content');
      if (megaMenuContent !== this.querySelector('.mega-menu__content')) { 
        menu.querySelector('summary').setAttribute('aria-expanded', false);
        menu.removeAttribute('open');
      } else { 
        menu.querySelector('summary').setAttribute('aria-expanded', true);
      }
    });

    this.querySelector('.mega-menu__content').style.opacity = 1;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true); 
    this.querySelector('summary').click(); 
    document.body.classList.add('menu-open');
  }
  hideMenu(){
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.mainDetailsToggle.querySelector('summary').click();
    document.body.classList.remove('menu-open');
  }
  onToggle() { 
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
customElements.define('header-menu', HeaderMenu);